<template>
    <div v-if="typeof message_doc.parsed_items != 'undefined'" class="user-join text-center note">
        {{$t("User")}}      
        <b v-if="typeof message_doc.parsed_items.user_id != 'undefined'" class="link" @click="ShowUser(message_doc.parsed_items.user_id)">
            {{GetUser(message_doc.parsed_items.user_id).username}}
        </b>
        <b v-else>
            {{message_doc.parsed_items.email}}
        </b>
          {{$t("deleted by")}} 
        <b class="link" @click="ShowUser(message_doc.user_id)">{{GetUser(message_doc.user_id).username}}</b>  {{$t("at")}}
        <b>{{new Date(message_doc.created_at * 1000).toLocaleDateString($i18n.locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric' })}}</b>
    </div>
</template>




<script>
import Vue from 'vue'
import Global from '../scripts/Global'
import { Post } from '../classes/Post'
import { CPUtils } from '../scripts/Utils'
import MessageBuilder from '../Builder/Message.builder'
import FileApi from '../scripts/api/file.api'
import { serverBus } from '../main'
import SessionManager from '../Manager/Session.manager'
import VueSignals from '@/scripts/VueSignals'
import CPLink from './CPLink'



export default {
  name: 'DeleteUserMessage',
  data: function() {
    return {
      postHoverID: ''
    }
  },  
  props: {
    message_doc: Object,
  },
  
  methods : {
      GetUser(user_id){              
          let user = SessionManager.getUser(user_id)
          if(typeof user.user_id == "undefined")
            SessionManager.makeUserCall(user_id).then(res=> {
              user =  SessionManager.getUser(user_id)
            })
          if(typeof user != 'undefined')
            return user

      return '' 
    },
    ShowUser(user_id){
        Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
        Global.globalValue(VueSignals.SHOW_MENTION_DETAILS, {
            "data_id": user_id,
            "type": 'user'
        })
    }
  }
}
</script>